import React from 'react'
import { Alert, HorizontalStack, Icon, ShowIf } from '@ztechapps/webui.util'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import { Stack } from 'react-bootstrap'
import { useValidateShipment } from './hooks/useValidateShipment'
import { useCheckoutContext } from './index'

export const CheckoutAlert = () => {
  const { fromStore, components, orderDocumentResult } = useCheckoutContext()
  const { document } = orderDocumentResult
  useValidateShipment()

  return (
    <ShowIf condition={fromStore && !isEmpty(document?.shipping?.serviceErrors)}>
      <Alert>
        <Stack gap={2}>
          <HorizontalStack gap={1}>
            <div>
              <Icon name={'warning'} />
              There is an error creating a shipment. Fix the error below and try again, or email us at
            </div>
            <components.emailLink />
          </HorizontalStack>
          <ul className={'mb-1'}>
            {map(document?.shipping?.serviceErrors, (item, index) => {
              return <li key={index}>"{item}"</li>
            })}
          </ul>
        </Stack>
      </Alert>
    </ShowIf>
  )
}
